module.exports = __webpack_public_path__ + "static/img/11.6661ef7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/11.jpg
// module id = UUoV
// module chunks = 21